import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Profile } from '../../../models/profile';
import { profileOptions } from '../../../models/profileOptions';
import { SiteParameterService } from '../../../services/siteparameter.service'
import { CloudStorageService } from '../../../services/cloud-storage';
import { OnPremStorageService } from '../../../services/onprem-storage';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmService } from '../../../services/confirmation.service';

@Component({
  selector: 'app-linked-agents',
  templateUrl: './linked-agents.component.html',
  styles: [
  ]
})
export class LinkedAgentsComponent implements OnInit {
  private setDefaultAgentUpdate: Subscription; //important to create a subscription
  private setDefaultChannelUpdate: Subscription; //important to create a subscription
  public profile!: Profile;
  public profileOptions!: profileOptions;
  public displayName = "";
  private defaultAgentId = "";
  private defaultChannel = "";

  constructor(public auth: AuthService, public cloudStorageService: CloudStorageService, public onPremStorageService: OnPremStorageService, private siteParmService: SiteParameterService,
    private toastr: ToastrService, private confirmService: ConfirmService, private router: Router) {
    this.setDefaultAgentUpdate = this.siteParmService.getDefaultAgentUpdate().subscribe
      (message => {
        this.defaultAgentId = message.value;
      });
    this.setDefaultChannelUpdate = this.siteParmService.getDefaultChannelUpdate().subscribe
      (message => {
        this.defaultChannel = message.value;
      });
  }

  ngOnInit(): void {
    this.profile = this.siteParmService.getStaticProfile();
    this.defaultAgentId = this.profile.selectedAgentNumber;
    this.displayName = this.profile.displayName;
    this.cloudStorageService.getProfileOptions(this.profile.auth0Id)
      .pipe(take(1))
      .subscribe((resp: any) => {
        this.profileOptions = resp;
      });
  }
  onSubmit(formData: any): void {
    this.cloudStorageService.updateProfile(this.profile.auth0Id, this.defaultAgentId, this.displayName)
      .pipe(take(1))
      .subscribe((resp: any) => {
        this.profile.defaultAgentNumber = this.defaultAgentId;
        this.profile.selectedAgentNumber = this.defaultAgentId;
        this.profile.channelPreference = this.defaultChannel;
        this.profile.displayName = this.displayName;
        this.siteParmService.setProfile(this.profile);
        this.toastr.success('Profile Successfully Updated', 'Update', {
          positionClass: 'toast-bottom-center'
        });
        this.siteParmService.sendParmServiceInit(null);
      });
  }
  async unlinkAgent(): Promise<void> {
    //const confirmed = window.confirm('Are you sure you want to unlink this agent?');
    const confirmed = await this.confirmService.confirm('Unlink Agent ID', 'Are you sure you want to unlink this Agent ID?');
    if (confirmed) {
      this.onPremStorageService.unlinkAgent(this.profile.emailAddress)
        .pipe(take(1))
        .subscribe((resp: any) => {
          this.toastr.success('Agent Successfully Unlinked', 'Unlink', {
            positionClass: 'toast-bottom-center'
          });
          this.siteParmService.sendParmServiceInit(null);
          setTimeout(() => {
            this.router.navigate(['/']).then(() => {
              window.location.reload();
            });
          }, 2000);
        }
        );
    }
  }
  ngOnDestroy() { // It's a good practice to unsubscribe to ensure no memory leaks
    this.setDefaultAgentUpdate.unsubscribe();
    this.setDefaultChannelUpdate.unsubscribe();
  }
}
